import { RootState } from '@/app/store'

export const selectDocumentTags = (state: RootState) => state.options.documentTags
export const selectContentTags = (state: RootState) => state.options.contentTags
export const selectSites = (state: RootState) => state.options.sites
export const selectManagers = (state: RootState) => state.options.managers
export const selectOptionsLoading = (state: RootState) => state.options.isLoading
export const selectOptionsError = (state: RootState) => state.options.error
